/**
 * @generated SignedSource<<080ea34bbd08a766c48a9093601c283f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommentList$data = {
  readonly comments: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Comment">;
  }>;
  readonly " $fragmentType": "CommentList";
};
export type CommentList$key = {
  readonly " $data"?: CommentList$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommentList",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "comments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Comment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MetaAd",
  "abstractKey": null
};

(node as any).hash = "6895fdc3a0568b3023eba9c754df1ac4";

export default node;
